import { render, staticRenderFns } from "./coupons-info.vue?vue&type=template&id=1ae2c521&scoped=true&"
import script from "./coupons-info.vue?vue&type=script&lang=js&"
export * from "./coupons-info.vue?vue&type=script&lang=js&"
import style0 from "./coupons-info.vue?vue&type=style&index=0&id=1ae2c521&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae2c521",
  null
  
)

export default component.exports